import Model from './Model';
import ServiceTime from './ServiceTime';

export default class CarUse extends Model {
  resource() {
    return 'car-uses';
  }

  serviceTimes() {
    return this.hasMany(ServiceTime);
  }
}
